<div class="flex flex-auto flex-col p-6 md:p-8" *ngIf=" fileDetails() as file">
    <!-- Close button -->
    <div class="flex items-center justify-end">
        <a mat-icon-button (click)="onClose()">
            <!-- ADD FUNCTIONALITY HERE -->
            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </a>
    </div>

    <!-- Preview -->
    <div class="mt-8 aspect-[15/7]">
        <div class="flex h-full items-center justify-center rounded-lg border bg-gray-50 dark:bg-card">
            <!-- <mat-icon class="text-hint icon-size-24" [svgIcon]="'heroicons_outline:document'"></mat-icon> -->
            <div class="relative">
                <mat-icon class="text-hint opacity-50 icon-size-24" [svgIcon]="
                        'heroicons_solid:document'
                    "></mat-icon>
                <div class="absolute bottom-0 left-0 rounded px-1.5 text-md font-semibold leading-5 text-white"
                    [ngClass]="{
                 'bg-red-600': file.extension === 'PDF',
                 'bg-blue-600': file.extension === 'DOCX' || file.extension === 'DOC',
                 'bg-green-600': file.extension === 'XLSX' || file.extension === 'XLS',
                 'bg-amber-600': file.extension === 'JPG',
                 'bg-yellow-600': file.extension === 'ZIP',
                 'bg-purple-600': file.extension === 'PNG',
                 'bg-gray-600': !['PDF', 'DOCX', 'DOC', 'XLSX', 'XLS', 'JPG', 'ZIP', 'PNG'].includes(file.extension)
               }">
                    {{ file.extension.toUpperCase() }}
                </div>
            </div>
        </div>
    </div>

    <!-- Name & Type -->
    <div class="mt-8 flex flex-col items-start">
        <div class="text-xl font-medium">{{ file.name }}</div>

    </div>

    <!-- Information -->
    <div class="mt-8 text-lg font-medium">Information</div>
    <div class="mt-4 flex flex-col divide-y border-b border-t font-medium">
        <div class="flex items-center justify-between py-3">
            <div class="text-secondary">Created By</div>
            <div>{{ file.uploadedBy.firstName }} {{ file.uploadedBy.surname }}</div>
        </div>
        <div class="flex items-center justify-between py-3">
            <div class="text-secondary">Uploaded At</div>
            <div>{{ file.createdAt | date:'dd MMMM yyyy HH:mm' }}</div>
        </div>
        <div class="flex items-center justify-between py-3">
            <div class="text-secondary">Size</div>
            <div>{{ file.sizeReadable }}</div>
        </div>
    </div>

    <!-- Description -->
    <!-- <div class="mt-8 flex items-center justify-between">
        <div class="text-lg font-medium">Description</div>
        <button mat-icon-button (click)="onEditDescription()">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
        </button>
    </div> -->
    <!-- <div class="mt-2 flex border-t">
        <div class="py-3">
            @if (file.description) {
            <div>{{ file.description }}</div>
            }
            @if (!file.description) {
            <div class="text-secondary italic">
                This is a description
            </div>
            }
        </div>
    </div> -->

    <!-- Actions -->
    <div class="mt-8 grid w-full grid-cols-2 gap-4">
        <button class="flex-auto" mat-flat-button [color]="'primary'" (click)="onDownloadFile()">
            Download
        </button>
        <button class="flex-auto" mat-stroked-button (click)="onDeleteFile()">Delete</button>
    </div>
</div>